import { BreakdownBuilder } from '../builders/breakdown.builder';
import { Breakdown } from '../models/breakdown';

export class BreakdownDirector {
	public static readonly VALUE_MULTIPLIER: number = 100;
	public static readonly defaultName: string = 'N/A';
	public static readonly defaultValue: number = 0.0;

	public construct(breakdownBuilder: BreakdownBuilder, breakdownJson: any, multiplyFlag: boolean, category?: string): Breakdown {
		if (!breakdownJson || !breakdownJson.value) {
			breakdownJson = Object.assign({}, { name: BreakdownDirector.defaultName, value: BreakdownDirector.defaultValue });
		} else if (!breakdownJson.name) {
			breakdownJson.name = BreakdownDirector.defaultName;
		}
		return breakdownBuilder
			.setName(breakdownJson.name)
			.setValue(
				breakdownJson.rescaledValue
					? multiplyFlag ? breakdownJson.rescaledValue * BreakdownDirector.VALUE_MULTIPLIER : breakdownJson.rescaledValue
					: multiplyFlag ? breakdownJson.value * BreakdownDirector.VALUE_MULTIPLIER : breakdownJson.value
			)
			.setCategoryName(category ? category : BreakdownDirector.defaultName)
			.build();
	}
}
